import Component from "./CKEditorComponent";

export default Component;
